// apps/web/src/hooks/use-conversations.ts
import useSWR from 'swr'
import { useCallback, useState } from 'react'
import { api } from '../lib/api-client'
import type { Conversation, PaginatedResult } from '@viecxanh/chat-shared'
import { PAGE_SIZE } from '../lib/constants'

interface ConversationFilters {
  channel_id?: string
  status?: 'open' | 'closed' | 'pending'
  assigned_to?: string
  q?: string
}

export function useConversations(filters: ConversationFilters = {}) {
  const [page, setPage] = useState(1)

  const params = { page, limit: PAGE_SIZE, ...filters }

  const key = `/api/admin/conversations?${new URLSearchParams(
    Object.fromEntries(
      Object.entries(params)
        .filter(([, v]) => v !== undefined)
        .map(([k, v]) => [k, String(v)]),
    ),
  ).toString()}`

  const { data, error, isLoading, mutate } = useSWR<PaginatedResult<Conversation>>(
    key,
    (url: string) => api.get<PaginatedResult<Conversation>>(url),
    { refreshInterval: 0 },
  )

  const markRead = useCallback(
    async (id: string) => {
      await api.put(`/api/admin/conversations/${id}/read`)
      await mutate()
    },
    [mutate],
  )

  return {
    conversations: data?.items ?? [],
    total: data?.total ?? 0,
    isLoading,
    error,
    page,
    setPage,
    markRead,
    mutate,
  }
}
